import { render, staticRenderFns } from "./stockcardDetails.vue?vue&type=template&id=6e05bc87&"
import script from "./stockcardDetails.vue?vue&type=script&lang=js&"
export * from "./stockcardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports